<template>
  <div class="checkList2" v-if="routeClass == 2">
    <search-form
      :searcharray="searcharray"
      :span="6"
      @change="search"
      @reset="reset"
    ></search-form>
    <el-table
      :data="tableData"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      style="width: 100%;margin-top:15px"
      row-key="id"
      stripe
      lazy
      size="small"
      class="teamTtable"
    >
      <!-- <el-table-column prop="num_id" align="center" label="流水号">
      </el-table-column> -->
      <el-table-column
        prop="policy_num"
        label="保单号"
        width="200"
        fixed="left"
        v-if="tableTitList4.policy_num.val"
      >
      </el-table-column>
      <el-table-column
        prop="correct_num"
        label="批单号"
        width="150"
        :fixed="fixedlist4.includes('correct_num')"
        v-if="tableTitList4.correct_num.val"
      >
        <template #header>
          <span>批单号</span>
          <span
            @click="fixed('correct_num')"
            class="fixedIcon"
            :class="{ activate: fixedlist4.includes('correct_num') }"
          >
            <i class="iconfont icon-guding"></i>
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="orderDesc"
        min-width="200"
        label="订单标识"
        show-overflow-tooltip
        :fixed="fixedlist4.includes('orderDesc')"
        v-if="tableTitList4.orderDesc.val"
      >
        <template #header>
          <span>订单标识</span>
          <span
            @click="fixed('orderDesc')"
            class="fixedIcon"
            :class="{ activate: fixedlist4.includes('orderDesc') }"
          >
            <i class="iconfont icon-guding"></i>
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="applicationName"
        label="投保人名称"
        width="200"
        show-overflow-tooltip
        :fixed="fixedlist4.includes('applicationName')"
        v-if="tableTitList4.applicationName.val"
      >
        <template #header>
          <span>投保人名称</span>
          <span
            @click="fixed('applicationName')"
            class="fixedIcon"
            :class="{ activate: fixedlist4.includes('applicationName') }"
          >
            <i class="iconfont icon-guding"></i>
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="insuredName"
        label="被保人名称"
        min-width="200"
        show-overflow-tooltip
        :fixed="fixedlist4.includes('insuredName')"
        v-if="tableTitList4.insuredName.val"
      >
        <template #header>
          <span>被保人名称</span>
          <span
            @click="fixed('insuredName')"
            class="fixedIcon"
            :class="{ activate: fixedlist4.includes('insuredName') }"
          >
            <i class="iconfont icon-guding"></i>
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="productName"
        label="产品名称"
        min-width="260"
        show-overflow-tooltip
        :fixed="fixedlist4.includes('productName')"
        v-if="tableTitList4.productName.val"
      >
        <template #header>
          <span>产品名称</span>
          <span
            @click="fixed('productName')"
            class="fixedIcon"
            :class="{ activate: fixedlist4.includes('productName') }"
          >
            <i class="iconfont icon-guding"></i>
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="companyName"
        label="保险公司"
        width="150"
        :fixed="fixedlist4.includes('companyName')"
        v-if="tableTitList4.companyName.val"
      >
        <template #header>
          <span>保险公司</span>
          <span
            @click="fixed('companyName')"
            class="fixedIcon"
            :class="{ activate: fixedlist4.includes('companyName') }"
          >
            <i class="iconfont icon-guding"></i>
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="c_time"
        label="创建时间"
        width="180"
        :fixed="fixedlist4.includes('c_time')"
        v-if="tableTitList4.c_time.val"
      >
        <template #header>
          <span>创建时间</span>
          <span
            @click="fixed('c_time')"
            class="fixedIcon"
            :class="{ activate: fixedlist4.includes('c_time') }"
          >
            <i class="iconfont icon-guding"></i>
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="s_time"
        label="生效时间"
        width="180"
        :fixed="fixedlist4.includes('s_time')"
        v-if="tableTitList4.s_time.val"
      >
        <template #header>
          <span>生效时间</span>
          <span
            @click="fixed('s_time')"
            class="fixedIcon"
            :class="{ activate: fixedlist4.includes('s_time') }"
          >
            <i class="iconfont icon-guding"></i>
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="e_time"
        label="截止时间"
        width="180"
        :fixed="fixedlist4.includes('e_time')"
        v-if="tableTitList4.e_time.val"
      >
        <template #header>
          <span>截止时间</span>
          <span
            @click="fixed('e_time')"
            class="fixedIcon"
            :class="{ activate: fixedlist4.includes('e_time') }"
          >
            <i class="iconfont icon-guding"></i>
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="policy_money"
        label="保费金额"
        width="150"
        :fixed="fixedlist4.includes('policy_money')"
        v-if="tableTitList4.policy_money.val"
      >
        <template #header>
          <span>保费金额</span>
          <span
            @click="fixed('policy_money')"
            class="fixedIcon"
            :class="{ activate: fixedlist4.includes('policy_money') }"
          >
            <i class="iconfont icon-guding"></i>
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="statusTxt"
        label="批单状态"
        width="100"
        :fixed="fixedlist4.includes('statusTxt')"
        v-if="tableTitList4.statusTxt.val"
      >
        <template #header>
          <span>批单状态</span>
          <span
            @click="fixed('statusTxt')"
            class="fixedIcon"
            :class="{ activate: fixedlist4.includes('statusTxt') }"
          >
            <i class="iconfont icon-guding"></i>
          </span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="work_cate_title" align="center" label="职业类别">
      </el-table-column> -->
      <el-table-column label="操作" fixed="right" width="200">
        <template #header>
          <span>操作</span>
          <el-dropdown :hide-on-click="false">
            <span class="el-dropdown-link">
              <i class="el-icon-s-grid"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(v, i) in tableTitList4" :key="i">
                <el-checkbox
                  v-model="v.val"
                  :label="v.name"
                  @change="tableTitList4Cheng"
                >
                </el-checkbox>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="look(scope.row.id)">
            查看
          </el-button>
          <el-button
            type="text"
            size="mini"
            @click="updata(scope.row.id)"
            v-if="scope.row.status == 11 || scope.row.isInsureFile == 1"
          >
            上传资料
          </el-button>
          <el-button
            type="text"
            size="mini"
            @click="pay(scope.row.id)"
            v-if="scope.row.status == 1"
          >
            继续付款
          </el-button>
          <el-button
            type="text"
            size="mini"
            @click="cancel(scope.row.id)"
            v-if="
              scope.row.status == 1 ||
                scope.row.status == 2 ||
                scope.row.status == 11 ||
                scope.row.status == 13
            "
          >
            取消
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="sizeChange"
      @current-change="currentChange"
      :page-sizes="pageSizeArray"
      :page-size.sync="pageSize"
      :current-page.sync="page"
      :total="total"
      background
      layout="total, sizes, prev, pager, next, jumper"
    >
    </el-pagination>
  </div>
  <router-view v-else />
</template>
<script>
import searchForm from "@/components/common/searchForm";
import { getCorrectionList, cancelCorrection } from "@/api/check";
import { getCompany } from "@/api/public";
export default {
  name: "checkList",
  data() {
    return {
      routeClass: "",
      searcharray: [
        {
          label: "保险公司",
          val: "company_id",
          type: "select",
          pla: "请选择保险公司",
          option: []
        },
        {
          label: "投保人名称",
          val: "applicationName",
          type: "input",
          pla: "请输入投保人名称"
        },
        {
          label: "被保人名称",
          val: "insuredName",
          type: "input",
          pla: "请输入被保人名称"
        },
        // {
        //   label: "流水号",
        //   val: "numId",
        //   type: "input",
        //   pla: "请输入流水号"
        // },
        {
          label: "保单号",
          val: "policyNum",
          type: "input",
          pla: "请输入保单号"
        },
        {
          label: "创建时间",
          val: "cTimeArr",
          type: "date"
        },
        {
          label: "批单号",
          val: "correctNum",
          type: "input",
          pla: "请输入批单号"
        },
        {
          label: "状态",
          val: "status",
          type: "select",
          pla: "请选择保单状态",
          option: [
            { label: "待支付", val: "1" },
            { label: "待审核", val: "2" },
            // { label: "审核成功", val: "3" },
            { label: "驳回", val: "4" },
            { label: "待生效", val: "5" },
            { label: "保障中", val: "6" },
            { label: "已过期", val: "7" },
            { label: "已取消", val: "8" },
            // { label: "申请退款", val: "9" },
            // { label: "已退款", val: "10" },
            { label: "待传资料", val: "11" }
            // { label: "保前审核", val: "13" }
          ]
        }
      ],
      searchData: {},
      loading: false,
      tableData: [],
      // 分页 每页条数
      pageSize: 15,
      // 分页 每页条数可选项
      pageSizeArray: [15, 30, 45, 60],
      // 当前页
      page: 1,
      // 总页数
      total: 0,
      fixedlist4: JSON.parse(localStorage.getItem("fixedlist4")),
      tableTitList4: JSON.parse(localStorage.getItem("tableTitList4"))
    };
  },
  components: {
    searchForm
  },
  beforeCreate() {
    // 判断是否有本地储存fixedlist4
    if (!localStorage.getItem("fixedlist4")) {
      localStorage.setItem("fixedlist4", JSON.stringify([]));
    }
    //判断是否有本地储存
    if (!localStorage.getItem("tableTitList4")) {
      localStorage.setItem(
        "tableTitList4",
        JSON.stringify({
          policy_num: {
            val: true,
            name: "保单号"
          },
          correct_num: {
            val: true,
            name: "批单号"
          },
          orderDesc: {
            val: true,
            name: "订单标识"
          },
          applicationName: {
            val: true,
            name: "投保人名称"
          },
          insuredName: {
            val: true,
            name: "被保人名称"
          },
          productName: {
            val: true,
            name: "产品名称"
          },
          companyName: {
            val: true,
            name: "保险公司"
          },
          c_time: {
            val: true,
            name: "创建时间"
          },
          s_time: {
            val: true,
            name: "生效时间"
          },
          e_time: {
            val: true,
            name: "截止时间"
          },
          policy_money: {
            val: true,
            name: "保费金额"
          },
          statusTxt: {
            val: true,
            name: "保单状态"
          }
        })
      );
    }
  },
  mounted() {
    // 获取当前路由等级
    this.routeClass = this.$route.matched.length;
    // 获取保司
    this.getCompany();
    // 获取列表
    this.getCorrectionList();
  },
  methods: {
    //列表固定
    fixed(e) {
      if (this.fixedlist4.includes(e)) {
        this.fixedlist4.splice(this.fixedlist4.indexOf(e), 1);
      } else {
        this.fixedlist4.push(e);
      }
      localStorage.setItem("fixedlist4", JSON.stringify(this.fixedlist4));
    },
    //展示列
    tableTitList4Cheng() {
      localStorage.setItem("tableTitList4", JSON.stringify(this.tableTitList4));
    },
    // 搜索数据
    search(e) {
      this.page = 1;
      this.searchData = e;
      this.getCorrectionList();
    },
    //搜索重置
    reset(e) {
      this.page = 1;
      this.searchData = {};
      this.getCorrectionList();
    },
    // 获取列表
    getCorrectionList() {
      let _data = this.searchData;
      let that = this;
      _data.page = this.page;
      _data.limit = this.pageSize;
      _data.identification = 1;
      that.loading = true;
      getCorrectionList(_data)
        .then(function(res) {
          console.log(res);
          that.loading = false;
          if (res.code == 1) {
            that.tableData = res.data.list;
            that.total = res.data.total;
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    // 每页几条
    sizeChange() {
      this.getCorrectionList();
    },
    // 页码变化
    currentChange() {
      this.getCorrectionList();
    },
    look(e) {
      // 查看
      this.$router.push({
        path: "/hr/staffChange/detail",
        query: { changeId: e }
      });
    },
    // 上传资料
    updata(e) {
      this.$router.push({
        path: "/check/upData",
        query: { changeId: e }
      });
    },
    // 支付
    pay(e) {
      this.$router.push({
        path: "/hr/staffChange/pay",
        query: { changeId: e }
      });
    },
    // 取消
    cancel(e) {
      console.log(e);
      let that = this;
      this.$confirm("此操作将取消该批单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        cancelCorrection({ changeId: e })
          .then(function(res) {
            console.log(res);
            if (res.code == 1) {
              that.$message.success(res.msg);
              that.getCorrectionList();
            } else {
              that.$message.error(res.msg);
            }
          })
          .catch(function(error) {
            console.log(error);
          });
      });
    },
    // 获取保司列表
    getCompany() {
      let that = this;
      getCompany()
        .then(function(res) {
          console.log(res);
          if (res.code == 1) {
            res.data.forEach((item, index) => {
              let _obj = { label: "", val: "" };
              _obj.label = item.name;
              _obj.val = item.id;
              that.searcharray[0].option.push(_obj);
            });
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }
};
</script>
<style lang="scss">
.checkList2 {
  & > .searchform {
    .el-row .el-form-item .el-form-item__content {
      button:first-child {
        color: #2ca063;
        border-color: #2ca063;
      }
      .el-button:focus,
      .el-button:hover {
        color: #2ca063;
        border-color: #2ca06321;
        background-color: #2ca06321;
      }
    }
  }
  .el-table {
    th {
      background: #f1f4f8;
    }
    th,
    td {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.85);
    }
    .cell {
      margin-left: 20px;
      .el-button {
        color: #2ca063;
      }
    }
    .fixedIcon {
      color: #c0c4cc;
      cursor: pointer;
      padding-left: 5px;
      vertical-align: middle;
      i {
        font-size: 14px;
      }
    }
    .fixedIcon.activate {
      color: #409eff57;
    }
    .el-dropdown {
      span {
        padding-left: 10px;
        i {
          font-size: 14px;
        }
      }
    }
  }
  & > .el-pagination {
    .el-pager {
      li:not(.disabled):hover {
        color: #2ca063;
      }
      li:not(.disabled).active {
        background: #2ca063;
        color: #fff;
      }
    }
  }
}
</style>
